export const dealsInclude =
	'client,client.building,salesman,salesmanVisit,salesmanVisit.products,team,organization';

export const dealsQueryBase = {
	state: 'deal',
	_sort: 'date_from',
	_limit: '5',
};
